import { render, staticRenderFns } from "./ArticleAuthors.vue?vue&type=template&id=54f36473&lang=html&"
import script from "./ArticleAuthors.vue?vue&type=script&lang=js&"
export * from "./ArticleAuthors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports